export default __webpack_public_path__ + "static/media/Group 7553.fa5df60c.png";